const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5334px",
    height: "3205px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#33b7d7",
    d: "M 2719.5,777.5 C 2784.19,775.748 2831.36,803.414 2861,860.5C 2870.01,881.896 2874.51,904.229 2874.5,927.5C 3007.38,984.545 3114.88,1072.55 3197,1191.5C 3197.67,1192.5 3197.67,1193.5 3197,1194.5C 3184.82,1192.5 3172.65,1190.33 3160.5,1188C 3084.41,1084.58 2987.58,1007.08 2870,955.5C 2848.09,1022.73 2801.75,1058.4 2731,1062.5C 2668.82,1059.44 2624.82,1029.77 2599,973.5C 2589.63,949.214 2586.8,924.214 2590.5,898.5C 2464.03,899.697 2346.36,932.197 2237.5,996C 2224.55,994.468 2211.89,991.468 2199.5,987C 2300.63,922.066 2411.3,884.399 2531.5,874C 2553.48,872.461 2575.48,871.295 2597.5,870.5C 2620.28,816.051 2660.95,785.051 2719.5,777.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#6753b1",
    d: "M 2709.5,1293.5 C 2710.58,1558.43 2711.24,1823.43 2711.5,2088.5C 2693.5,2098.17 2675.5,2107.83 2657.5,2117.5C 2657.23,1891.5 2656.9,1665.5 2656.5,1439.5C 2513.81,1419.59 2371.14,1399.59 2228.5,1379.5C 2228.83,1393.01 2228.5,1406.34 2227.5,1419.5C 2227.17,1405.82 2227.5,1392.15 2228.5,1378.5C 2235.73,1374.73 2242.73,1370.73 2249.5,1366.5C 2265.94,1358.11 2282.27,1349.45 2298.5,1340.5C 2299.5,1279.84 2299.83,1219.17 2299.5,1158.5C 2162.22,1139.52 2024.89,1120.52 1887.5,1101.5C 1943.66,1069.67 2000.5,1039 2058,1009.5C 2194.17,1028.67 2330.33,1047.83 2466.5,1067C 2467.33,1128.76 2467.83,1190.6 2468,1252.5C 2468.23,1255.09 2468.73,1257.59 2469.5,1260C 2549.49,1271.33 2629.49,1282.5 2709.5,1293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#513e81",
    d: "M 1887.5,1101.5 C 2024.89,1120.52 2162.22,1139.52 2299.5,1158.5C 2299.83,1219.17 2299.5,1279.84 2298.5,1340.5C 2282.27,1349.45 2265.94,1358.11 2249.5,1366.5C 2249.5,1354.83 2249.5,1343.17 2249.5,1331.5C 2205.46,1325.78 2161.46,1319.78 2117.5,1313.5C 2117.5,1343.83 2117.5,1374.17 2117.5,1404.5C 2154.2,1409.21 2190.87,1414.21 2227.5,1419.5C 2227.5,1435.17 2227.5,1450.83 2227.5,1466.5C 2190.83,1461.5 2154.17,1456.5 2117.5,1451.5C 2117.5,1481.83 2117.5,1512.17 2117.5,1542.5C 2154.23,1547.13 2190.89,1552.13 2227.5,1557.5C 2227.5,1573.17 2227.5,1588.83 2227.5,1604.5C 2191.15,1599.59 2154.82,1594.59 2118.5,1589.5C 2118.5,1619.83 2118.5,1650.17 2118.5,1680.5C 2153.52,1684.98 2188.52,1689.65 2223.5,1694.5C 2224.92,1695.45 2226.59,1695.78 2228.5,1695.5C 2228.5,1711.17 2228.5,1726.83 2228.5,1742.5C 2191.83,1737.5 2155.17,1732.5 2118.5,1727.5C 2118.5,1757.83 2118.5,1788.17 2118.5,1818.5C 2155.22,1823.13 2191.89,1828.13 2228.5,1833.5C 2228.5,1849.17 2228.5,1864.83 2228.5,1880.5C 2191.83,1875.5 2155.17,1870.5 2118.5,1865.5C 2118.5,1895.83 2118.5,1926.17 2118.5,1956.5C 2153.87,1960.89 2189.2,1965.55 2224.5,1970.5C 2225.57,1971.43 2226.9,1971.77 2228.5,1971.5C 2228.5,1983.17 2228.5,1994.83 2228.5,2006.5C 2115.54,1990.55 2002.54,1974.89 1889.5,1959.5C 1889.2,1673.49 1888.53,1387.49 1887.5,1101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2070.5,1194.5 C 2071.15,1213.86 2070.49,1232.86 2068.5,1251.5C 2025.76,1245.97 1983.09,1239.97 1940.5,1233.5C 1939.5,1203.51 1939.17,1173.51 1939.5,1143.5C 1983.22,1149.13 2026.89,1155.13 2070.5,1161.5C 2070.5,1172.5 2070.5,1183.5 2070.5,1194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2117.5,1168.5 C 2161.18,1174.39 2204.85,1180.39 2248.5,1186.5C 2248.67,1216.84 2248.5,1247.17 2248,1277.5C 2204.87,1271.12 2161.7,1264.79 2118.5,1258.5C 2117.5,1228.51 2117.17,1198.51 2117.5,1168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#6753b1",
    d: "M 3122.5,2178.5 C 3122.23,1892.83 3121.73,1607.17 3121,1321.5C 2984.1,1301.19 2846.93,1281.86 2709.5,1263.5C 2764.78,1232.52 2820.45,1202.02 2876.5,1172C 3014.13,1190.23 3151.63,1209.4 3289,1229.5C 3290.01,1515.5 3290.34,1801.5 3290,2087.5C 3234.26,2118.09 3178.43,2148.42 3122.5,2178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a50a7",
    d: "M 2070.5,1194.5 C 2071.5,1213.66 2071.83,1232.99 2071.5,1252.5C 2070.21,1252.74 2069.21,1252.4 2068.5,1251.5C 2070.49,1232.86 2071.15,1213.86 2070.5,1194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#513e81",
    d: "M 2709.5,1263.5 C 2846.93,1281.86 2984.1,1301.19 3121,1321.5C 3121.73,1607.17 3122.23,1892.83 3122.5,2178.5C 2985.53,2159.25 2848.53,2140.25 2711.5,2121.5C 2711.5,2110.5 2711.5,2099.5 2711.5,2088.5C 2711.24,1823.43 2710.58,1558.43 2709.5,1293.5C 2709.5,1283.5 2709.5,1273.5 2709.5,1263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 1939.5,1288.5 C 1983.14,1294.69 2026.81,1300.69 2070.5,1306.5C 2071.27,1336.83 2071.61,1367.16 2071.5,1397.5C 2027.54,1391.22 1983.54,1385.22 1939.5,1379.5C 1939.5,1349.17 1939.5,1318.83 1939.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2760.5,1305.5 C 2804.57,1311.03 2848.57,1317.03 2892.5,1323.5C 2892.83,1353.84 2892.5,1384.17 2891.5,1414.5C 2848.19,1407.98 2804.86,1401.65 2761.5,1395.5C 2760.5,1365.51 2760.17,1335.51 2760.5,1305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2249.5,1366.5 C 2242.73,1370.73 2235.73,1374.73 2228.5,1378.5C 2227.5,1392.15 2227.17,1405.82 2227.5,1419.5C 2190.87,1414.21 2154.2,1409.21 2117.5,1404.5C 2117.5,1374.17 2117.5,1343.83 2117.5,1313.5C 2161.46,1319.78 2205.46,1325.78 2249.5,1331.5C 2249.5,1343.17 2249.5,1354.83 2249.5,1366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2938.5,1330.5 C 2982.53,1336.28 3026.53,1342.28 3070.5,1348.5C 3070.67,1378.84 3070.5,1409.17 3070,1439.5C 3026.24,1432.94 2982.4,1426.61 2938.5,1420.5C 2938.5,1390.5 2938.5,1360.5 2938.5,1330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#5d4794",
    d: "M 2657.5,2117.5 C 2514.56,2097.13 2371.56,2077.13 2228.5,2057.5C 2228.5,2040.5 2228.5,2023.5 2228.5,2006.5C 2228.5,1994.83 2228.5,1983.17 2228.5,1971.5C 2229.83,1950.83 2229.83,1930.17 2228.5,1909.5C 2228.5,1899.83 2228.5,1890.17 2228.5,1880.5C 2228.5,1864.83 2228.5,1849.17 2228.5,1833.5C 2228.5,1803.17 2228.5,1772.83 2228.5,1742.5C 2228.5,1726.83 2228.5,1711.17 2228.5,1695.5C 2228.83,1665 2228.5,1634.66 2227.5,1604.5C 2227.5,1588.83 2227.5,1573.17 2227.5,1557.5C 2228.4,1527.33 2228.4,1497 2227.5,1466.5C 2227.5,1450.83 2227.5,1435.17 2227.5,1419.5C 2228.5,1406.34 2228.83,1393.01 2228.5,1379.5C 2371.14,1399.59 2513.81,1419.59 2656.5,1439.5C 2656.9,1665.5 2657.23,1891.5 2657.5,2117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 1941.5,1517.5 C 1940.85,1505.07 1940.19,1492.73 1939.5,1480.5C 1939.5,1462.5 1939.5,1444.5 1939.5,1426.5C 1983.49,1432.59 2027.49,1438.59 2071.5,1444.5C 2071.5,1474.83 2071.5,1505.17 2071.5,1535.5C 2028.16,1529.59 1984.82,1523.59 1941.5,1517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2292.5,1449.5 C 2392.15,1463.26 2491.82,1476.93 2591.5,1490.5C 2591.5,1523.17 2591.5,1555.83 2591.5,1588.5C 2492.11,1575.14 2392.77,1561.31 2293.5,1547C 2292.5,1514.57 2292.17,1482.07 2292.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2760.5,1450.5 C 2804.47,1456.72 2848.47,1462.72 2892.5,1468.5C 2892.5,1498.83 2892.5,1529.17 2892.5,1559.5C 2848.89,1553.13 2805.22,1547.13 2761.5,1541.5C 2761.55,1511.16 2761.22,1480.83 2760.5,1450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2227.5,1466.5 C 2228.4,1497 2228.4,1527.33 2227.5,1557.5C 2190.89,1552.13 2154.23,1547.13 2117.5,1542.5C 2117.5,1512.17 2117.5,1481.83 2117.5,1451.5C 2154.17,1456.5 2190.83,1461.5 2227.5,1466.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2938.5,1475.5 C 2982.49,1481.59 3026.49,1487.59 3070.5,1493.5C 3070.5,1523.83 3070.5,1554.17 3070.5,1584.5C 3026.56,1578.03 2982.56,1572.03 2938.5,1566.5C 2938.5,1536.17 2938.5,1505.83 2938.5,1475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8664d2",
    d: "M 1939.5,1480.5 C 1940.19,1492.73 1940.85,1505.07 1941.5,1517.5C 1939.52,1505.55 1938.85,1493.21 1939.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 1939.5,1564.5 C 1983.47,1570.72 2027.47,1576.72 2071.5,1582.5C 2071.5,1612.83 2071.5,1643.17 2071.5,1673.5C 2027.89,1667.13 1984.22,1661.13 1940.5,1655.5C 1940.05,1625.17 1939.71,1594.83 1939.5,1564.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2761.5,1588.5 C 2805.17,1594.5 2848.83,1600.5 2892.5,1606.5C 2892.5,1636.83 2892.5,1667.17 2892.5,1697.5C 2848.86,1691.31 2805.19,1685.31 2761.5,1679.5C 2761.5,1649.17 2761.5,1618.83 2761.5,1588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2227.5,1604.5 C 2227.5,1634.5 2227.5,1664.5 2227.5,1694.5C 2226.17,1694.5 2224.83,1694.5 2223.5,1694.5C 2188.52,1689.65 2153.52,1684.98 2118.5,1680.5C 2118.5,1650.17 2118.5,1619.83 2118.5,1589.5C 2154.82,1594.59 2191.15,1599.59 2227.5,1604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2292.5,1601.5 C 2392.54,1615.22 2492.54,1629.22 2592.5,1643.5C 2592.5,1676.17 2592.5,1708.83 2592.5,1741.5C 2492.47,1728.02 2392.47,1714.35 2292.5,1700.5C 2292.5,1667.5 2292.5,1634.5 2292.5,1601.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 3070.5,1679.5 C 3070.5,1693.5 3070.5,1707.5 3070.5,1721.5C 3069.17,1721.5 3067.83,1721.5 3066.5,1721.5C 3024.18,1715.74 2981.85,1710.07 2939.5,1704.5C 2939.5,1674.17 2939.5,1643.83 2939.5,1613.5C 2983.17,1619.5 3026.83,1625.5 3070.5,1631.5C 3070.5,1647.5 3070.5,1663.5 3070.5,1679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8563d1",
    d: "M 2227.5,1604.5 C 2228.5,1634.66 2228.83,1665 2228.5,1695.5C 2226.59,1695.78 2224.92,1695.45 2223.5,1694.5C 2224.83,1694.5 2226.17,1694.5 2227.5,1694.5C 2227.5,1664.5 2227.5,1634.5 2227.5,1604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8664d2",
    d: "M 3070.5,1679.5 C 3071.5,1693.66 3071.83,1707.99 3071.5,1722.5C 3069.59,1722.78 3067.92,1722.45 3066.5,1721.5C 3067.83,1721.5 3069.17,1721.5 3070.5,1721.5C 3070.5,1707.5 3070.5,1693.5 3070.5,1679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 1940.5,1702.5 C 1984.17,1708.5 2027.83,1714.5 2071.5,1720.5C 2071.5,1750.83 2071.5,1781.17 2071.5,1811.5C 2027.86,1805.31 1984.19,1799.31 1940.5,1793.5C 1940.5,1763.17 1940.5,1732.83 1940.5,1702.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2892.5,1744.5 C 2893.16,1774.85 2892.49,1804.85 2890.5,1834.5C 2847.52,1828.74 2804.52,1823.07 2761.5,1817.5C 2761.5,1787.17 2761.5,1756.83 2761.5,1726.5C 2805.15,1732.61 2848.82,1738.61 2892.5,1744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2228.5,1742.5 C 2228.5,1772.83 2228.5,1803.17 2228.5,1833.5C 2191.89,1828.13 2155.22,1823.13 2118.5,1818.5C 2118.5,1788.17 2118.5,1757.83 2118.5,1727.5C 2155.17,1732.5 2191.83,1737.5 2228.5,1742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7759bb",
    d: "M 2892.5,1744.5 C 2893.5,1774.66 2893.83,1805 2893.5,1835.5C 2892.21,1835.74 2891.21,1835.4 2890.5,1834.5C 2892.49,1804.85 2893.16,1774.85 2892.5,1744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2939.5,1751.5 C 2983.49,1757.59 3027.49,1763.59 3071.5,1769.5C 3071.5,1799.83 3071.5,1830.17 3071.5,1860.5C 3027.86,1854.29 2984.19,1848.12 2940.5,1842C 2939.5,1811.91 2939.17,1781.74 2939.5,1751.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2592.5,1795.5 C 2592.83,1828.67 2592.5,1861.67 2591.5,1894.5C 2492.48,1880.9 2393.48,1867.07 2294.5,1853C 2292.51,1820.39 2291.84,1787.56 2292.5,1754.5C 2392.51,1768.17 2492.51,1781.83 2592.5,1795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b51aa",
    d: "M 2592.5,1795.5 C 2593.83,1828.67 2593.83,1862 2592.5,1895.5C 2591.89,1895.38 2591.56,1895.04 2591.5,1894.5C 2592.5,1861.67 2592.83,1828.67 2592.5,1795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2071.5,1867.5 C 2072.16,1894.85 2071.49,1921.85 2069.5,1948.5C 2026.51,1942.74 1983.51,1937.07 1940.5,1931.5C 1940.5,1901.17 1940.5,1870.83 1940.5,1840.5C 1984.15,1846.61 2027.82,1852.61 2071.5,1858.5C 2071.5,1861.5 2071.5,1864.5 2071.5,1867.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2765.5,1955.5 C 2764.79,1954.6 2763.79,1954.26 2762.5,1954.5C 2762.83,1929.99 2762.5,1905.66 2761.5,1881.5C 2761.5,1875.83 2761.5,1870.17 2761.5,1864.5C 2805.51,1870.41 2849.51,1876.41 2893.5,1882.5C 2893.5,1912.83 2893.5,1943.17 2893.5,1973.5C 2850.84,1967.43 2808.18,1961.43 2765.5,1955.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2228.5,1880.5 C 2228.5,1890.17 2228.5,1899.83 2228.5,1909.5C 2228.5,1929.83 2228.5,1950.17 2228.5,1970.5C 2227.17,1970.5 2225.83,1970.5 2224.5,1970.5C 2189.2,1965.55 2153.87,1960.89 2118.5,1956.5C 2118.5,1926.17 2118.5,1895.83 2118.5,1865.5C 2155.17,1870.5 2191.83,1875.5 2228.5,1880.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8664d2",
    d: "M 2071.5,1867.5 C 2072.5,1894.66 2072.83,1921.99 2072.5,1949.5C 2071.21,1949.74 2070.21,1949.4 2069.5,1948.5C 2071.49,1921.85 2072.16,1894.85 2071.5,1867.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8664d2",
    d: "M 2761.5,1881.5 C 2762.5,1905.66 2762.83,1929.99 2762.5,1954.5C 2763.79,1954.26 2764.79,1954.6 2765.5,1955.5C 2764.17,1955.5 2762.83,1955.5 2761.5,1955.5C 2761.5,1930.83 2761.5,1906.17 2761.5,1881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2939.5,1889.5 C 2983.51,1895.41 3027.51,1901.41 3071.5,1907.5C 3071.5,1937.83 3071.5,1968.17 3071.5,1998.5C 3027.86,1992.31 2984.2,1986.31 2940.5,1980.5C 2939.64,1950.18 2939.31,1919.84 2939.5,1889.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2293.5,1907.5 C 2392.87,1921.01 2492.21,1934.84 2591.5,1949C 2592.5,1981.43 2592.83,2013.93 2592.5,2046.5C 2492.82,2032.93 2393.16,2019.26 2293.5,2005.5C 2293.5,1972.83 2293.5,1940.17 2293.5,1907.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d52ab",
    d: "M 2228.5,1909.5 C 2229.83,1930.17 2229.83,1950.83 2228.5,1971.5C 2226.9,1971.77 2225.57,1971.43 2224.5,1970.5C 2225.83,1970.5 2227.17,1970.5 2228.5,1970.5C 2228.5,1950.17 2228.5,1929.83 2228.5,1909.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#33b7d7",
    d: "M 1976.5,1990.5 C 1988.28,1991.38 1999.95,1992.88 2011.5,1995C 2101.89,2125.25 2222.23,2216.41 2372.5,2268.5C 2390.93,2210.57 2429.93,2175.73 2489.5,2164C 2558.59,2157.28 2609.09,2184.45 2641,2245.5C 2648.61,2263.4 2653.11,2282.07 2654.5,2301.5C 2779.04,2289.72 2892.38,2248.22 2994.5,2177C 3007.91,2177.82 3021.24,2179.49 3034.5,2182C 2921.53,2268.06 2793.87,2316.9 2651.5,2328.5C 2638.58,2389.59 2601.91,2428.09 2541.5,2444C 2485.49,2453.89 2438.65,2437.72 2401,2395.5C 2378.08,2366.25 2367.25,2332.92 2368.5,2295.5C 2213.31,2243.86 2088.47,2151.52 1994,2018.5C 1987.89,2009.28 1982.06,1999.95 1976.5,1990.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2761.5,2002.5 C 2805.49,2008.59 2849.49,2014.59 2893.5,2020.5C 2893.83,2050.84 2893.5,2081.17 2892.5,2111.5C 2849.26,2104.85 2805.93,2098.85 2762.5,2093.5C 2762.71,2063.16 2762.38,2032.82 2761.5,2002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9871ee",
    d: "M 2940.5,2027.5 C 2984.15,2033.61 3027.82,2039.61 3071.5,2045.5C 3071.83,2075.84 3071.5,2106.17 3070.5,2136.5C 3027.26,2129.85 2983.93,2123.85 2940.5,2118.5C 2940.5,2088.17 2940.5,2057.83 2940.5,2027.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.477fe7c98f46f392a3947bd1cd2bf257.svg";
export { ForwardRef as ReactComponent };